// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './exchanges-api';

export const useListExchanges: typeof hookExports.useListExchanges = hookExports.useListExchanges;
export const useLazyListExchanges: typeof hookExports.useLazyListExchanges =
  hookExports.useLazyListExchanges;
export const useGetExchange: typeof hookExports.useGetExchange = hookExports.useGetExchange;
export const useLazyGetExchange: typeof hookExports.useLazyGetExchange =
  hookExports.useLazyGetExchange;
export const useCreateExchange: typeof hookExports.useCreateExchange =
  hookExports.useCreateExchange;
export const useUpdateExchange: typeof hookExports.useUpdateExchange =
  hookExports.useUpdateExchange;
export const useDeleteExchange: typeof hookExports.useDeleteExchange =
  hookExports.useDeleteExchange;
export const useSyncExchange: typeof hookExports.useSyncExchange = hookExports.useSyncExchange;
export const useGetExchangeChangelogs: typeof hookExports.useGetExchangeChangelogs =
  hookExports.useGetExchangeChangelogs;
export const useLazyGetExchangeChangelogs: typeof hookExports.useLazyGetExchangeChangelogs =
  hookExports.useLazyGetExchangeChangelogs;
export const useGetExchangeSyncLogs: typeof hookExports.useGetExchangeSyncLogs =
  hookExports.useGetExchangeSyncLogs;
export const useLazyGetExchangeSyncLogs: typeof hookExports.useLazyGetExchangeSyncLogs =
  hookExports.useLazyGetExchangeSyncLogs;
export const useListPublicExchanges: typeof hookExports.useListPublicExchanges =
  hookExports.useListPublicExchanges;
export const useLazyListPublicExchanges: typeof hookExports.useLazyListPublicExchanges =
  hookExports.useLazyListPublicExchanges;
export const useListExchangeIps: typeof hookExports.useListExchangeIps =
  hookExports.useListExchangeIps;
export const useLazyListExchangeIps: typeof hookExports.useLazyListExchangeIps =
  hookExports.useLazyListExchangeIps;
export const useCreateExchangeIp: typeof hookExports.useCreateExchangeIp =
  hookExports.useCreateExchangeIp;
export const useUpdateExchangeIp: typeof hookExports.useUpdateExchangeIp =
  hookExports.useUpdateExchangeIp;
export const useDeleteExchangeIp: typeof hookExports.useDeleteExchangeIp =
  hookExports.useDeleteExchangeIp;
export const useListExchangeRegions: typeof hookExports.useListExchangeRegions =
  hookExports.useListExchangeRegions;
export const useLazyListExchangeRegions: typeof hookExports.useLazyListExchangeRegions =
  hookExports.useLazyListExchangeRegions;
export const useCreateExchangeRegion: typeof hookExports.useCreateExchangeRegion =
  hookExports.useCreateExchangeRegion;
export const useDeleteExchangeRegion: typeof hookExports.useDeleteExchangeRegion =
  hookExports.useDeleteExchangeRegion;
